/* eslint-disable react/jsx-no-target-blank */
import React, { FC } from 'react'
import { Link } from 'react-router-dom'
import { KTSVG, toAbsoluteUrl } from '../../../helpers'
import { AsideMenu } from './AsideMenu'

const AsideDefault: FC = () => {
  return (
    <>
      <style>{`
        /* ══════════════════════════════════════════
           ASIDE — Modern Sidebar (light + dark)
        ══════════════════════════════════════════ */

        #kt_aside {
          /* ── Aydınlık tema (varsayılan) ── */
          --as-bg: #ffffff;
          --as-border: #e4e6ef;
          --as-scroll: rgba(0,0,0,.18);
          --as-brand: #181c32;
          --as-hairline: rgba(0,0,0,.07);

          --as-toggle-bg: #f4f4f6;
          --as-toggle-fg: #7e8299;
          --as-toggle-bg-hover: #e9e9ef;
          --as-toggle-fg-hover: #181c32;

          --as-link: #5e6278;
          --as-link-hover: #181c32;
          --as-link-hover-bg: #f4f4f6;
          --as-icon: #a1a5b7;
          --as-active-fg: #181c32;
          --as-bullet: rgba(0,0,0,.2);
          --as-arrow: #b5b5c3;
          --as-arrow-strong: #7e8299;
          --as-sub-link: #7e8299;
          --as-sub-link-hover: #181c32;

          background: var(--as-bg) !important;
          border-right: 1px solid var(--as-border);
          display: flex;
          flex-direction: column;
        }

        /* ── Karanlık tema ── */
        html[data-theme-mode='dark'] #kt_aside {
          --as-bg: #13131f;
          --as-border: rgba(255,255,255,.06);
          --as-scroll: rgba(255,255,255,.1);
          --as-brand: #ffffff;
          --as-hairline: rgba(255,255,255,.07);

          --as-toggle-bg: rgba(255,255,255,.06);
          --as-toggle-fg: rgba(255,255,255,.4);
          --as-toggle-bg-hover: rgba(255,255,255,.1);
          --as-toggle-fg-hover: #ffffff;

          --as-link: rgba(255,255,255,.5);
          --as-link-hover: rgba(255,255,255,.9);
          --as-link-hover-bg: rgba(255,255,255,.06);
          --as-icon: rgba(255,255,255,.35);
          --as-active-fg: #ffffff;
          --as-bullet: rgba(255,255,255,.2);
          --as-arrow: rgba(255,255,255,.2);
          --as-arrow-strong: rgba(255,255,255,.5);
          --as-sub-link: rgba(255,255,255,.4);
          --as-sub-link-hover: rgba(255,255,255,.85);
        }

        /* ── Logo alanı ── */
        .aside-logo {
          display: flex; align-items: center; justify-content: space-between;
          padding: 16px 20px 12px;
          border-bottom: 1px solid var(--as-hairline);
          flex-shrink: 0;
        }
        .aside-logo__brand {
          display: flex; align-items: center; gap: 10px;
          text-decoration: none;
        }
        .aside-logo__img { width: 32px; height: 32px; border-radius: 8px; object-fit: contain; }
        .aside-logo__name {
          font-size: 17px; font-weight: 700; letter-spacing: -.02em;
          color: var(--as-brand);
        }
        .aside-toggle-btn {
          width: 28px; height: 28px; border-radius: 8px; border: none; cursor: pointer;
          display: flex; align-items: center; justify-content: center;
          background: var(--as-toggle-bg); color: var(--as-toggle-fg);
          transition: background .15s, color .15s;
        }
        .aside-toggle-btn:hover { background: var(--as-toggle-bg-hover); color: var(--as-toggle-fg-hover); }
        .aside-toggle-btn .svg-icon,
        .aside-toggle-btn .svg-icon i { color: inherit !important; }
        .aside-toggle-btn svg [fill]:not([fill='none']) { fill: currentColor !important; }

        /* ── Menü scroll alanı ── */
        #kt_aside_menu_wrapper {
          flex: 1;
          overflow-y: auto;
          padding: 8px 12px 24px;
          margin: 0;
          scrollbar-width: thin;
          scrollbar-color: var(--as-scroll) transparent;
        }
        #kt_aside_menu_wrapper::-webkit-scrollbar { width: 4px; }
        #kt_aside_menu_wrapper::-webkit-scrollbar-track { background: transparent; }
        #kt_aside_menu_wrapper::-webkit-scrollbar-thumb {
          background: var(--as-scroll); border-radius: 2px;
        }

        /* ══ Menu Item ortak stilleri ══ */

        .ami-item { margin-bottom: 2px; }

        .ami-link {
          display: flex; align-items: center; gap: 10px;
          padding: 9px 12px; border-radius: 9px;
          text-decoration: none; position: relative;
          transition: background .15s, color .15s;
          color: var(--as-link);
        }
        .ami-link:hover {
          background: var(--as-link-hover-bg);
          color: var(--as-link-hover);
        }
        .ami-link:hover .ami-icon { color: var(--theme-primary, #009ef7); }

        /* Aktif link */
        .ami-link--active {
          background: rgba(var(--theme-primary-rgb, 0,158,247), .12) !important;
          color: var(--as-active-fg) !important;
        }
        .ami-link--active .ami-icon {
          color: var(--theme-primary, #009ef7) !important;
        }
        .ami-link--active .ami-title { font-weight: 600; }

        /* Sol aktif çizgi */
        .ami-active-bar {
          position: absolute; left: 0; top: 20%; bottom: 20%;
          width: 3px; border-radius: 0 3px 3px 0;
          background: var(--theme-primary, #009ef7);
        }

        /* Disabled */
        .ami-link--disabled {
          opacity: .35;
          pointer-events: none;
        }

        /* İkon */
        .ami-icon {
          width: 20px; flex-shrink: 0; display: flex;
          align-items: center; justify-content: center;
          color: var(--as-icon);
          transition: color .15s;
        }

        /* Başlık */
        .ami-title {
          font-size: 13px; font-weight: 500; flex: 1;
          white-space: nowrap; overflow: hidden; text-overflow: ellipsis;
          letter-spacing: -.01em;
        }

        /* Bullet (hasBullet için) */
        .ami-bullet {
          width: 6px; height: 6px; border-radius: 50%; flex-shrink: 0;
          background: var(--as-bullet);
          margin-left: 4px;
        }
        .ami-link--active .ami-bullet { background: var(--theme-primary, #009ef7); }

        /* ══ Sub menü ══ */

        .amis-item { margin-bottom: 2px; }

        .amis-trigger {
          cursor: pointer; user-select: none;
        }

        /* Ok ikonu */
        .amis-arrow {
          color: var(--as-arrow); flex-shrink: 0;
          transition: transform .2s, color .15s;
          display: flex; align-items: center;
        }
        .amis-arrow--open { transform: rotate(180deg); color: var(--as-arrow-strong); }
        .ami-link:hover .amis-arrow { color: var(--as-arrow-strong); }

        /* Disabled parent */
        .amis-item--disabled > .ami-link {
          opacity: .35; pointer-events: none;
        }

        /* Alt menü container */
        .amis-sub {
          display: none;
          padding-left: 14px;
          margin-top: 2px;
        }
        .amis-sub--open { display: block; }

        /* Alt menü items — bullet yerine ince sol çizgi */
        .amis-sub .ami-item { position: relative; }
        .amis-sub .ami-item::before {
          content: '';
          position: absolute; left: 10px; top: 0; bottom: 0;
          width: 1px;
          background: var(--as-hairline);
        }
        .amis-sub .ami-link {
          padding: 7px 10px 7px 28px;
          font-size: 12px; color: var(--as-sub-link);
        }
        .amis-sub .ami-link:hover { color: var(--as-sub-link-hover); }
        .amis-sub .ami-link--active { color: var(--as-active-fg) !important; }
        .amis-sub .ami-icon { width: 16px; }
        .amis-sub .ami-title { font-size: 12px; }

        /* ── Mobil overlay drawer ── */
        @media (max-width: 991px) {
          #kt_aside { width: 260px !important; }
        }
      `}</style>

      <div
        id='kt_aside'
        className='aside'
        data-kt-drawer='true'
        data-kt-drawer-name='aside'
        data-kt-drawer-activate='{default: true, lg: false}'
        data-kt-drawer-overlay='true'
        data-kt-drawer-width="{default:'260px', '300px': '260px'}"
        data-kt-drawer-direction='start'
        data-kt-drawer-toggle='#kt_aside_mobile_toggle'
      >
        {/* ── Logo ── */}
        <div className='aside-logo' id='kt_aside_logo'>
          <Link to='/home' className='aside-logo__brand'>
            <img
              alt='Logo'
              className='aside-logo__img'
              src={toAbsoluteUrl('/media/logos/netway.png')}
            />
            <span className='aside-logo__name'>Wisnet</span>
          </Link>

          <button
            id='kt_aside_toggle'
            className='aside-toggle-btn'
            data-kt-toggle='true'
            data-kt-toggle-state='active'
            data-kt-toggle-target='body'
            data-kt-toggle-name='aside-minimize'
            title='Menüyü küçült'
          >
            <KTSVG
              path='/media/icons/duotune/arrows/arr080.svg'
              className='svg-icon-4'
            />
          </button>
        </div>

        {/* ── Menü ── */}
        <div className='aside-menu flex-column-fluid'>
          <AsideMenu asideMenuCSSClasses={[]} />
        </div>
      </div>
    </>
  )
}

export { AsideDefault }